let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Gz3J2")).then(() => parcelRequire('gDFQl'));